import type { MouseEventHandler } from 'react'
import { DownloadIcon } from '@mote/assets/icons'
import { Tooltip } from '../TooltipV2'
import { IconButton } from '../button'
import type { ShareButtonProps } from './ShareButton'
import { ShareButton } from './ShareButton'
import { ClassroomIcon, EmbedIcon, QrCodeIcon } from './ShareIcons'
import { StyledSharePanel } from './SharePanel.styles'
import { useSharePanelContext } from './SharePanelContext'

export interface SharePanelProps extends Pick<ShareButtonProps, 'variant'> {
  onEmbedClick: MouseEventHandler<HTMLButtonElement>
  onClassroomClick: MouseEventHandler<HTMLButtonElement>
  onDownloadClick: MouseEventHandler<HTMLButtonElement>
  shareLinkButton?: JSX.Element
  onQRCodeClick: MouseEventHandler<HTMLButtonElement>
  isClassroomButtonHidden?: boolean
  isDownloadButtonHidden?: boolean
}

export function SharePanel(props: SharePanelProps) {
  const sharePanelContext = useSharePanelContext()

  if (sharePanelContext.view !== 'initial') {
    return <></>
  }

  return (
    <StyledSharePanel>
      <ShareButton
        onClick={e => {
          props.onEmbedClick(e)
          sharePanelContext.setView('embed')
        }}
        text={'Embed'}
        icon={<EmbedIcon />}
        variant={props.variant}
      />
      <ShareButton
        onClick={e => {
          props.onQRCodeClick(e)
          sharePanelContext.setView('qrcode')
        }}
        text={'QR code'}
        icon={<QrCodeIcon />}
        variant={props.variant}
      />
      {props.isClassroomButtonHidden ? null : (
        <ShareButton
          variant={props.variant}
          onClick={props.onClassroomClick}
          text={'Classroom'}
          icon={<ClassroomIcon />}
        />
      )}
      {props.shareLinkButton}
      {!props.isDownloadButtonHidden &&
        (props.variant === 'text' ? (
          <ShareButton
            variant={'text'}
            onClick={props.onDownloadClick}
            text={'Download'}
            icon={<DownloadIcon />}
          />
        ) : (
          <>
            <IconButton
              data-tip
              data-for={'download'}
              //@ts-expect-error
              onClick={props.onDownloadClick}
              icon={<DownloadIcon />}
            />
            <Tooltip id={'download'}>Download</Tooltip>
          </>
        ))}
    </StyledSharePanel>
  )
}
